module.exports = __webpack_public_path__ + "static/media/green_line_faq.0c503f14.svg";